/* tslint:disable:ordered-imports */

import 'zone.js';
import 'rxjs';
import 'rxjs/operators';

import 'ngx-cookie-service';
import 'tslib';

// 'platform-browser-dynamic' is removed in production builds.
// It's only used in JiT mode.
import '@angular/platform-browser-dynamic';

import '@angular/animations';
import '@angular/core';
import '@angular/common';
import '@angular/common/http';
import '@angular/forms';
import '@angular/platform-browser';
import '@angular/platform-browser/animations';
import '@angular/router';
import '@aria/webjs-sdk';

import 'resize-observer-polyfill';
import 'requestidlecallback';
import 'ng-in-viewport';
import 'intersection-observer';

// Polyfills for office-start
import 'url-polyfill';
import EventTarget from '@ungap/event-target'; // polyfill for tabster.
import 'regenerator-runtime/runtime'; // polyfill for babel.

// React
import * as React from 'react';
import * as ReactDOM from 'react-dom';

// Store Zone.js Promise for backup later in case it gets overwritten.
// This can be reset in the WindowService.ensureZoneJs.
window.ZoneJSBackupPromise = window.Promise;

window.React = React;
window.ReactDOM = ReactDOM;
window.EventTarget = EventTarget;
